<template>
  <div v-show="isCardActiveLocal" class="contentCards" vs-align="center" :style="{ position: 'relative'}">
    <div>
      <div class="vx-row mt-2">
        <div class="vx-col w-full mb-2" style="text-align: -webkit-center;text-align: -moz-center;">
          <h5>Error retrieving results.</h5>
          <vs-progress :percent="100" color="danger"></vs-progress>
          <vs-button icon-pack="feather" icon="icon-refresh-ccw" color="success" type="flat" class="mt-4 vs-con-loading__container cursor-pointer" @click="retry">Retry</vs-button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    components: {
      
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;

          
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) { }
      },
    },
    methods: {
      retry() {
        this.$emit("retry");
        this.$emit("hideView");
      }
    }
  };
</script>

<style lang="scss">
  .contentCards {
    margin: auto;
  }
</style>
